import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalTitle: {
    id: 'studio.ULlRxz',
    defaultMessage: 'SAML secret',
  },
  iconLabel: {
    id: 'studio.kk4TVW',
    defaultMessage: 'Icon',
  },
  iconHelp: {
    id: 'studio.zzKGTH',
    defaultMessage:
      'The Font Awesome icon that will be displayed on the login button, or an `icon:` reference to a key from the app’s `icons` registry',
  },
  submitError: {
    id: 'studio.8TH0bj',
    defaultMessage: 'Something went wrong trying to save the secret',
  },
  nameLabel: {
    id: 'studio.HAlOn1',
    defaultMessage: 'Name',
  },
  nameHelp: {
    id: 'studio.+s1Ayf',
    defaultMessage: 'The name that will be displayed on the login button',
  },
  acsUrlLabel: {
    id: 'studio.o2wQir',
    defaultMessage: 'Attribute consume service endpoint',
  },
  acsUrlHelp: {
    id: 'studio.sotU5O',
    defaultMessage: 'This URL serves metadata for Appsemble as service provider',
  },
  acsUrlCopySuccess: {
    id: 'studio.6w7eKk',
    defaultMessage: 'Attribute consume service endpoint copied to clipboard',
  },
  acsUrlCopyError: {
    id: 'studio.lw7Bus',
    defaultMessage: 'Failed to copy attribute consume service endpoint to clipboard',
  },
  acsUrlPlaceholder: {
    id: 'studio.5qOtTw',
    defaultMessage: 'This will be generated once this secret is saved',
  },
  idpEntityIdLabel: {
    id: 'studio.BQptVD',
    defaultMessage: 'Identity provider entity ID',
  },
  idpEntityIdHelp: {
    id: 'studio.ypYcOj',
    defaultMessage: 'This URL serves metadata for the identify provider',
  },
  emailAttributeLabel: {
    id: 'studio.4H3a38',
    defaultMessage: 'Email attribute',
  },
  emailAttributeHelp: {
    id: 'studio.RGofbg',
    defaultMessage:
      'If specified, this SAML attribute is used to determine the user’s email address',
  },
  emailVerifiedAttributeLabel: {
    id: 'studio.tVSG3w',
    defaultMessage: 'Email verified attribute',
  },
  emailVerifiedAttributeHelp: {
    id: 'studio.4DJroh',
    defaultMessage:
      'If specified, this SAML attribute is used to determine if the user’s email address is verified',
  },
  nameAttributeLabel: {
    id: 'studio.KtTNmO',
    defaultMessage: 'Name attribute',
  },
  nameAttributeHelp: {
    id: 'studio.4G2zTe',
    defaultMessage:
      'If specified, this SAML attribute is used to determine the user’s display name',
  },
  objectIdAttributeLabel: {
    id: 'studio.7MMlMV',
    defaultMessage: 'Object ID attribute',
  },
  objectIdAttributeHelp: {
    id: 'studio.hh9BSl',
    defaultMessage:
      "If specified, this SAML attribute is used to determine the user's object ID. Required if there is a SCIM connection present.",
  },
  groupAttributeLabel: {
    id: 'studio.dRetPl',
    defaultMessage: 'Group attribute',
  },
  groupAttributeHelp: {
    id: 'studio.BqF3QB',
    defaultMessage:
      'If specified, this SAML attribute is used to read one or more external groups. Required when role mappings are configured.',
  },
  roleMappingsLabel: {
    id: 'studio.Q9LqJX',
    defaultMessage: 'Role mappings',
  },
  roleMappingsHelp: {
    id: 'studio.u6ZJe+',
    defaultMessage:
      'Configure exact external-group to app-role mappings. When mappings are configured, users without a match cannot sign in.',
  },
  idpCertificateLabel: {
    id: 'studio.qGxjxU',
    defaultMessage: 'Identity provider certificate',
  },
  idpCertificateHelp: {
    id: 'studio.SCiO7S',
    defaultMessage: 'The certificate that may be used to validate login requests',
  },
  ssoUrlLabel: {
    id: 'studio.fA8/KP',
    defaultMessage: 'Login endpoint',
  },
  ssoUrlHelp: {
    id: 'studio.cg0zJf',
    defaultMessage: 'This is where the user will be redirected when they press the login button',
  },
  spEntityIdLabel: {
    id: 'studio.2IBHyh',
    defaultMessage: 'Service provider entity ID',
  },
  spEntityIdHelp: {
    id: 'studio.7BmoTf',
    defaultMessage:
      'Copy this into the service provider entity ID field of the identity provider settings',
  },
  spEntityIdCopySuccess: {
    id: 'studio.RW6qwB',
    defaultMessage: 'Service provider entity ID copied to clipboard',
  },
  spEntityIdCopyError: {
    id: 'studio.izGBOh',
    defaultMessage: 'Failed to copy service provider entity ID to clipboard',
  },
  spEntityIdPlaceholder: {
    id: 'studio.5qOtTw',
    defaultMessage: 'This will be generated once this secret is saved',
  },
  spCertificateLabel: {
    id: 'studio./TwSx+',
    defaultMessage: 'Service provider certificate',
  },
  spCertificateHelp: {
    id: 'studio.Lo8rJD',
    defaultMessage: 'The certificate used to verify the service provider.',
  },
  spCertificateCopySuccess: {
    id: 'studio.lctTpH',
    defaultMessage: 'Service provider certificate copied to clipboard',
  },
  spCertificateCopyError: {
    id: 'studio.DRXLjG',
    defaultMessage: 'Failed to copy the service provider certificate to clipboard',
  },
  spCertificatePlaceholder: {
    id: 'studio.AXmu+f',
    defaultMessage: 'The certificate will be generated once this secret is saved',
  },
  badUrl: {
    id: 'studio.SHiPSp',
    defaultMessage: 'This must be a valid URL',
  },
  close: {
    id: 'studio.rbrahO',
    defaultMessage: 'Close',
  },
  save: {
    id: 'studio.UC1YWm',
    defaultMessage: 'Save secret',
  },
  deleteWarningTitle: {
    id: 'studio.t4NVlC',
    defaultMessage: 'Deleting secret',
  },
  deleteWarning: {
    id: 'studio.n5Sqbb',
    defaultMessage: 'Are you sure you want to delete this secret? This action cannot be reverted.',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  delete: {
    id: 'studio.9uCErh',
    defaultMessage: 'Delete secret',
  },
  deleteSuccess: {
    id: 'studio.ueImzj',
    defaultMessage: 'Successfully deleted secret {name}',
  },
  deleteButton: {
    id: 'studio.9uCErh',
    defaultMessage: 'Delete secret',
  },
});
